import { render, staticRenderFns } from "./RoApcn.vue?vue&type=template&id=08146a2d&"
import script from "./RoApcn.vue?vue&type=script&lang=js&"
export * from "./RoApcn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports